/* global FormUtils */
document.addEventListener('DOMContentLoaded', function () {
    const legalFormLogic = window.initRegistrationForm('registraion-legal-form');
    if (!legalFormLogic) return;

    const formElement = document.getElementById('registraion-legal-form');

    formElement.addEventListener('submit', function (e) {
        let isValid = legalFormLogic.validateBaseFields();

        const innInp = document.getElementById('input_UF_LEGAL_INN');
        if (innInp) {
            if (!/^(\d{10}|\d{12})$/.test(innInp.value)) {
                isValid = false;
                FormUtils.showFieldError(innInp, '*ИНН должен содержать 10 или 12 цифр');
            }
        }

        const kppInp = document.getElementById('input_UF_LEGAL_KPP');
        if (kppInp) {
            if (!/^[\d]{9}$/.test(kppInp.value)) {
                isValid = false;
                FormUtils.showFieldError(kppInp, '*КПП должен содержать ровно 9 цифр');
            }
        }

        if (!isValid) {
            e.preventDefault();
        }
    });
});
